import script from "./NoticeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeItem.vue?vue&type=script&setup=true&lang=js"

import "./NoticeItem.vue?vue&type=style&index=0&id=5aee9cf4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aee9cf4"]])

export default __exports__